import { Modal, ModalBody, ModalDialog, ModalHeader, ModalTitle } from '@ax/ui';
import VisitForm from './VisitForm';

interface VisitFormModalProps {
  modalOpen?: boolean;
  modalClose?: () => void;
  modalData?: VisitModalData;
  refetchData?: () => void;
}

export interface VisitModalData {
  uuid?: string;
  patientName?: string;
  appointmentStartTime?: string;
  visitDate?: string;
  patientAge?: number;
  patientGender?: string;
  chiefComplaint?: string;
  roomNumber?: string;
}

const VisitFormModal: React.FC<VisitFormModalProps> = ({
  modalOpen = false,
  modalClose,
  modalData,
  refetchData,
}) => {
  const handleModalClose = () => modalClose?.();
  const handleRefetchData = () => refetchData?.();

  return (
    <Modal onShow={modalOpen}>
      <ModalDialog>
        <ModalHeader onHide={handleModalClose}>
          <ModalTitle>{modalData ? 'Edit visit' : 'Add visit'}</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <VisitForm
            modalClose={handleModalClose}
            refetchData={handleRefetchData}
            modalData={modalData}
          />
        </ModalBody>
      </ModalDialog>
    </Modal>
  );
};

export default VisitFormModal;
